module.exports = __webpack_public_path__ + "static/media/crossland-homes-logo.835bb188.svg";